export default __webpack_public_path__ + "static/Leon Michalak Frontend Developer CV-e2413e7bcba10ce1c94f05479cc6a1b7.pdf";